import { GiftOutlined } from "@ant-design/icons";
import BirthdayViewAllBtn from "./buttons/BirthdayViewAllBtn";
import { Empty } from "antd";
import { useCurrentBirthday } from "../../../app/hooks/useCurrentBirthday";

export const BirthdayRecord = [
  {
    id: 0,
    name: "Pedro Penduko MG",
    photo: "https://xsgames.co/randomusers/avatar.php?g=pixel&key=2",
    age: 23,
  },
  {
    id: 1,
    name: "Mike Pacquaioasdf",
    photo: "https://xsgames.co/randomusers/avatar.php?g=pixel&key=1",
    age: 43,
  },
  {
    id: 2,
    name: "Mike Pacquaioasdf",
    photo: "https://xsgames.co/randomusers/avatar.php?g=pixel&key=1",
    age: 26,
  },
];

const Birthdays = () => {
  const { currentDate } = useCurrentBirthday();
  return (
    <div
      style={{ display: "flex", justifyContent: "flex-start" }}
      className="right-side-card-container"
    >
      {/* temporary icon */}
      <GiftOutlined style={{ fontSize: 50, margin: 30 }} />
      <div style={{ textAlign: "center", width: "250px" }}>
        <h3>Birthday</h3>
        {currentDate === undefined || currentDate.length == 0 ? (
          <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        ) : (
          <div>
            <span>
              {currentDate.map((birthday, index) => {
                return (
                  <span key={birthday.id}>
                    {(index
                      ? birthday.id === currentDate.length - 1
                        ? " and "
                        : ", "
                      : "") +
                      birthday.firstName +
                      " " +
                      birthday.lastName +
                      " "}
                  </span>
                );
              })}
              <span>
                {currentDate.length == 1 ? "has a" : "have"}{" "}
                {currentDate.length == 1 ? "birthday" : "birthdays"} today.
              </span>
            </span>
            <BirthdayViewAllBtn />
          </div>
        )}
      </div>
    </div>
  );
};

export default Birthdays;
